import { render, staticRenderFns } from "./irrigationAddArea.vue?vue&type=template&id=175bdb32&scoped=true"
import script from "./irrigationAddArea.vue?vue&type=script&lang=js"
export * from "./irrigationAddArea.vue?vue&type=script&lang=js"
import style0 from "./irrigationAddArea.vue?vue&type=style&index=0&id=175bdb32&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "175bdb32",
  null
  
)

export default component.exports